export default {
	// Config
	apiKey: "AIzaSyCzgxe3Vr_HKyTB-kAuvv5cJ57cGYmlQaY",
  authDomain: "gramlin-mytrace.firebaseapp.com",
  projectId: "gramlin-mytrace",
  storageBucket: "gramlin-mytrace.firebasestorage.app",
  messagingSenderId: "353371865327",
  appId: "1:353371865327:web:5ce0eae657b3ea45359b1a"
};
